// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceDestinationSettingsActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  const { curry } = require('lodash/fp');
  var SourceDestinationSettingsActions = compose(
    withHandlers({
      buildTitle: curry(buildTitle)
    })
  );

  /**
   * Build title
   * @param {Object} props
   * @returns {String} title
   */
  function buildTitle(props, _) {
    var localization = props.localization;
    var item = props.item;
    var title = '';
    var copySettingsText = localization.getText('COMMON_LABEL_COPY_SETTINGS');

    if (item.copyDataConnector) {
      title = localization.getText('COMMON_LABEL_DATA_CONNECTORS');
    }

    if (item.copyDataModel) {
      title += (title === '' ? '' : ', ') + localization.getText('COMMON_LABEL_DATA_MODEL');
    }

    if (item.copyDashboard) {
      title += (title === '' ? '' : ', ') + localization.getText('COMMON_LABEL_DASHBOARDS');
    }

    if (item.copyReport) {
      title += (title === '' ? '' : ', ') + localization.getText('COMMON_LABEL_REPORT');
    }

    if (title !== '') {
      title += ' ' + copySettingsText;
      var lastIndex = title.lastIndexOf(',');
      if (lastIndex >= 0) {
        title = title.substring(0, lastIndex) + ' and' + title.substring(lastIndex + 1, title.length);
      }
      return title;
    } else {
      return copySettingsText;
    }
  }

  module.exports = SourceDestinationSettingsActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceDestination/Izenda.SourceDestinationSettingsActions.js